import { ReactNode, useCallback, useRef } from 'react';
import { useZoomPan } from './useZoomPan';
import { ZoomControls } from './ZoomControls';

interface Props {
  children: ReactNode;
  controlsTopOffset?: string;
}

export function ZoomableWrapper(props: Props) {
  const { children, controlsTopOffset = '0' } = props;
  const contentRef = useRef<HTMLDivElement>(null);
  const {
    zoomLevel,
    isZoomed,
    isPanning,
    isDragging,
    translate,
    onZoomIn,
    onZoomOut,
    onReset,
    onPointer,
    onPan,
    onMouseDown,
    onMouseMove,
    onMouseUp,
  } = useZoomPan();

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      if (isZoomed) {
        e.stopPropagation();
      }
    },
    [isZoomed]
  );

  return (
    <div className="group/zoomable relative h-full w-full overflow-hidden">
      <div
        ref={contentRef}
        className="h-full w-full"
        style={{
          transform: `translate(${translate.x}px, ${translate.y}px) scale(${zoomLevel})`,
          transformOrigin: 'center center',
        }}
      >
        {children}
      </div>

      {isZoomed && (
        <div
          className="absolute inset-0 z-[5]"
          style={{
            cursor: isPanning ? (isDragging ? 'grabbing' : 'grab') : 'default',
            pointerEvents: isPanning ? 'auto' : 'none',
          }}
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onMouseLeave={onMouseUp}
          onClick={handleClick}
        />
      )}

      <ZoomControls
        isZoomed={isZoomed}
        isPanning={isPanning}
        onZoomIn={onZoomIn}
        onZoomOut={onZoomOut}
        onReset={onReset}
        onPointer={onPointer}
        onPan={onPan}
        topOffset={controlsTopOffset}
      />
    </div>
  );
}

export default ZoomableWrapper;
